export const documentsListInitValue = {
  data: {
    totalDocuments: 0,
    documents: [],
    section: '',
    currentFolderId: '',
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeItemsPerPage: () => {},
    handleAddDocument: () => {},
    handleOpenDocument: () => {},
    handleDeleteDocument: () => {},
    handleUploadFiles: () => Promise.resolve(),
  },
};
